module.exports = __webpack_public_path__ + "static/media/map-placeholder.1264ee6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-placeholder.jpg
// module id = 157
// module chunks = 0 1